module.exports = new __parcel__URL__("line-chart-development.6278a877.svg").toString();